import notice from '../../page/system/notice'

const routes = [
    {
        path: '/system/notice',
        component: notice
    }
];

export default {
    routes
};